// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProvinceDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ProvinceApiClient extends BaseCRUDApiClient<ProvinceDto> {
  baseUrl = this.config.apiEndpoint + '/province';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
